import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  loading: {
    textAlign: 'center',
    padding: '2.81rem 0',
  },
})
